import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {useUserCityId} from 'modules/locations/hooks/useUserCityId';
import {selectCities} from 'modules/locations/selectors';
import {MAIN_CITIES_IDS, MAIN_CONTACTS, MOSCOW_CITY_ID} from 'modules/footer/components/Footer/constants';
import {mountainContactsList} from 'modules/footer/helpers';
import {TContact} from 'modules/footer/components/Footer/types';

export const useContactsList = (): TContact[] => {
    const citiesList = useAppSelector(selectCities);

    const currentCityId = useUserCityId();

    const isMainCurrentCity = MAIN_CITIES_IDS.some((id) => id === currentCityId || !currentCityId);

    const mainCitiesList = citiesList.filter(({id}) =>
        isMainCurrentCity
            ? MAIN_CITIES_IDS.some((mainId) => id === mainId)
            : id === MOSCOW_CITY_ID || id === currentCityId,
    );

    return [MAIN_CONTACTS[0], ...mountainContactsList(mainCitiesList), ...MAIN_CONTACTS.slice(1)];
};
